"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
require("./avatarApload.scss");
const react_spinners_1 = require("react-spinners");
const avatarUploadTooltip_1 = require("./avatarUploadTooltip/avatarUploadTooltip");
const svgIcons_1 = require("../../../svgIcons");
const avatar = require('../../../assets/images/svg/image-removebg-preview.svg');
const CustomTooltip = core_1.withStyles({
    popper: {
        zIndex: 750
    },
    tooltip: {
        color: "#333333",
        backgroundColor: "#fff",
        padding: "14px 0",
        borderRadius: "6px",
        border: "1px solid #E8E8ED"
    },
    arrow: {
        color: "#fff",
        fontSize: "2rem",
        "&::before": {
            border: "1px solid #E8E8ED"
        }
    }
})(core_1.Tooltip);
const AvatarUpload = (props) => {
    const { user, guest, avatarLoading } = props, [tooltipActive, setTooltipActive] = react_1.useState(false);
    let fileInput = null;
    const handleTooltipClose = () => {
        setTimeout(() => {
            setTooltipActive(false);
        }, 500);
    };
    const handleTooltipOpen = () => setTooltipActive(true);
    const handleChange = (e) => {
        //@ts-ignore
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData["id"] = user.id;
        props.uploadAvatar(formData);
        if (fileInput) {
            fileInput.value = "";
        }
    };
    const removeAvatar = () => {
        if (!user.imageUrl)
            return false;
        handleTooltipClose();
        props.removeAvatar(user);
    };
    return avatarLoading ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: 'avatar-loader avatar-label' },
            react_1.default.createElement(core_1.Avatar, { className: 'd-100', color: 'var(--color-primary)' },
                react_1.default.createElement(react_spinners_1.ClipLoader, { color: 'var(--color-primary)', loading: true }))))) : (guest ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: 'avatar-label' },
            react_1.default.createElement(core_1.Avatar, { alt: user.name, className: `avatar-img ${!user.imageUrl ? 'default' : ''}`, color: 'primary', src: user.imageUrl || avatar.default })))) :
        (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("input", { onChange: (e) => handleChange(e), className: 'avatar-selector', accept: "image/*", ref: ref => fileInput = ref, id: "avatar-upload", type: "file" }),
            react_1.default.createElement("label", { className: 'avatar-label' },
                react_1.default.createElement("label", { "data-qa": 'img-upload-label-1', htmlFor: "avatar-upload", className: 'avatar-upload' },
                    react_1.default.createElement(core_1.Avatar, { alt: user.name, className: `avatar-img ${!user.imageUrl ? 'default' : ''}`, color: 'primary', src: user.imageUrl || avatar.default })),
                react_1.default.createElement(core_1.ClickAwayListener, { mouseEvent: "onMouseDown", onClickAway: handleTooltipClose },
                    react_1.default.createElement(CustomTooltip, { PopperProps: { disablePortal: true }, className: 'avatar-tooltip', title: react_1.default.createElement(avatarUploadTooltip_1.AvatarEditTooltip, { removeAvatar: removeAvatar, user: user }), onClose: handleTooltipClose, open: tooltipActive, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, arrow: true, interactive: true }, !user.imageUrl ? react_1.default.createElement("label", { className: 'photo-icon', "data-qa": 'img-upload-label-2', htmlFor: 'avatar-upload' },
                        react_1.default.createElement(svgIcons_1.PhotoIcon, null)) :
                        react_1.default.createElement("div", { onClick: handleTooltipOpen, className: "photo-icon" },
                            react_1.default.createElement(svgIcons_1.PhotoIcon, null))))))));
};
exports.default = AvatarUpload;
